import { ActionMap } from '@/store/store.interface';

import { LoadingPayloadType, LoadingActions, LoadingType } from './loading.interface';

export type LoadingActionsType = ActionMap<LoadingPayloadType>[keyof ActionMap<LoadingPayloadType>];

export const LoadingReducer = (state: LoadingType, action: LoadingActionsType) => {
  switch (action.type) {
    case LoadingActions.Load:
      return {
        loading: true,
        count: state.count + 1,
      };
    case LoadingActions.Loaded:
      return {
        loading: state.count > 1,
        count: state.count - 1,
      };
    default:
      return state;
  }
};
